<template>
  <div class="tw-w-full tw-border-t tw-border-theme-1" />
</template>
